import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_ROUTE_DOWLOAND_LOADING = 'GET_ROUTE_DOWLOAND_LOADING';
export const GET_ROUTE_DOWLOAND_SUCCESS = 'GET_ROUTE_DOWLOAND_SUCCESS';
export const GET_ROUTE_DOWLOAND_REJECT = 'GET_ROUTE_DOWLOAND_REJECT';

//* ACTIONS ------------------------------------------------
export const getRouteDowloandLoading = () => ({ type: GET_ROUTE_DOWLOAND_LOADING });
export const getRouteDowloandSuccess = (payload) => ({ type: GET_ROUTE_DOWLOAND_SUCCESS, payload });
export const getRouteDowloandReject = (payload) => ({ type: GET_ROUTE_DOWLOAND_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getRouteDowloandRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.GET,
        data,
    }, getState);
    return request(`/Route/web/GetRoutesDowloand?StartDate=${data.startDate}&EndDate=${data.endDate}`, options);
};

